module.exports = __webpack_public_path__ + "3f390630387e8a79b8825c8071b8345f.svg";